module.exports = __webpack_public_path__ + "img/zensocial-favicon.png";